import { render } from "./product-seo-detail.vue?vue&type=template&id=f33c2aac"
import script from "./product-seo-detail.vue?vue&type=script&lang=js"
export * from "./product-seo-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__